module.exports = __webpack_public_path__ + "static/media/edelgard-vonhresvelg-lose.489006d3.png";